module.exports = __webpack_public_path__ + "static/img/icon_c_apple.39765ec0.svg";